import { ca } from '@cian/analytics';

import { IJsonQuery } from 'shared/json_query';

export function trackAdFoxBannerClick(jsonQuery: IJsonQuery, bannerName: string) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'trap',
    label: 'AdFox_banner',
    event: 'oldevent',
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      extra: {
        trap_type: 'AdFox',
        bannerName,
        trapid: bannerName,
      },
    },
  });
}

export function trackAdFoxBannerView(jsonQuery: IJsonQuery, bannerName: string) {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'trap',
    label: 'AdFox_banner',
    event: 'oldevent',
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      extra: {
        trap_type: 'AdFox',
        bannerName,
        trapid: bannerName,
      },
    },
  });
}
